import {defineStore} from "pinia";
import load from "@/common/load";
import {axiosPost, getLabelList} from "@/layouts/admin-sidebar/requstDev";
import api from "@/service/api";
import userStore from "@/stores/user";

export default defineStore('tagStore', {
    persist: {
        enabled: true,
        strategies: [{key: 'tagStore', storage: sessionStorage}]
    },
    state() {
        /*初始数据列表*/
        return {
            tagListInfo: [], // 存储列表
            tagListData: [],
            filterTag: [],
            tagId: "", // 筛选值
            leftTagId: "", // 筛选值
            // 当前选择的标签列表
            currentTagList: {}, // 右侧
            currentTagListInfo: {}, // 左侧标签列表底下的名单
            currentFilterListInfo: {}, // 左侧标签列表底下的名单筛选
            currentTagName: {
                tagId: '',
                tagName: ''
            },
            leftCurrentTag: {
                tagId: '',
                tagName: ''
            },
            editValue: "", // 修改后的标签name
            insertValue: "", // 新增后的标签name
        }
    },
    actions: {
        /**
         * @Date: 2024-06-21 13:29:55
         * @LastEditors:ahuan
         * @description:获取标签列表
         * @return: 返回值
         */
        async initTagList() {
            try {
                load.loading("加载标签列表.......");
                let result = await getLabelList({
                    "userId": "admin"
                })
                if (result.result === '1') {
                    load.loaded();
                    this.$state.tagListData = [...result.data];
                    this.$state.filterTag = [...result.data];
                    this.$state.tagListInfo = [...result.data];
                    await this.getTagDev(result.data[0],true)
                } else {
                    load.error(result.msg)
                }
            } catch (e) {
                load.error("获取设备标签列表失败")
            }
        },
        /**
         * @Date: 2024-06-21 13:29:38
         * @LastEditors:ahuan
         * @description:tagChange 过滤标签列表
         * @return: 返回值
         */
        tagChange() {
            let list = this.$state.filterTag.filter(item => {
                return item.tagName.includes(this.$state.tagId);
            })
            this.$state.tagListData = list;
        },
        /**
         * @Date: 2024-06-21 13:29:38
         * @LastEditors:ahuan
         * @description:tagChange 过滤标签列表
         * @return: 返回值
         */
        leftTagChange() {
            let list = this.$state.filterTag.filter(item => {
                return item.tagName.includes(this.$state.leftTagId);
            })
            this.$state.tagListInfo = list;
        },
         /**
         * @Date: 2024-06-21 15:07:21
         * @LastEditors:ahuan
         * @description:获取该标签下的设备
         * @return: 返回值
         */
        async getTagDev(tag,type =false) {
            let user = userStore();
            if(!type){
                this.$state.currentTagName.tagName = tag.tagName;
                this.$state.currentTagName.tagId = tag.tagId;
            }else{
                this.$state.leftCurrentTag.tagName = tag.tagName;
                this.$state.leftCurrentTag.tagId = tag.tagId;
            }
            try {
                let result = await axiosPost(api.devtaglist, {
                    tagId: tag.tagId,
                    userId:user.userId
                })
                if (result.result === '1') {
                    if(!type){
                        this.$state.currentTagList = {...result.data};
                    }else{
                        this.$state.currentTagListInfo = {...result.data};
                    }
                    this.$state.currentFilterListInfo = {...result.data};
                } else {
                    this.$state.currentTagList = {};
                    this.$state.currentTagListInfo = {};
                    this.$state.currentFilterListInfo = {};
                    load.error(result.msg);
                }
            } catch (e) {
                load.error("获取标签列表失败")
            }
        },
        /*
        * 修改该标签
        * */
        async edit() {
            let user = userStore();
            if (!this.$state.editValue) return load.error("请输入内容...");
            this.$state.editValue = this.$state.editValue.trim();
            try {
                load.loading("修改中...")
                let result = await axiosPost(api.editTagName, {
                    userId: user.userId,
                    data: {
                        tagId: this.$state.currentTagName.tagId,
                        newTagName: this.$state.editValue
                    }
                })
                load.loaded();
                if (result.result === '1') {
                    this.initTagList();
                    load.success('修改成功');
                    this.$state.currentTagName.tagName = this.$state.editValue;
                } else {
                    load.error(result.msg);
                }
            } catch (e) {
                load.error("修改标签失败...")
            }
        },
        /*  新增标签 */
        async insert() {
            let user = userStore();
            if (!this.$state.insertValue) return load.error("请输入标签名称...")
            this.$state.insertValue = this.$state.insertValue.trim();
            try {
                load.loading("新增中...")
                let result = await axiosPost(api.insertTag, {
                    userId: user.userId,
                    data: {
                        newTagName: this.$state.insertValue
                    }
                })
                load.loaded();
                if (result.result === '1') {
                    this.initTagList();
                    load.success('新增成功');
                } else {
                    load.error(result.msg);
                }
            } catch (e) {
                load.error("新增标签失败...")
            }
        }
    }
})
